module.exports = __webpack_public_path__ + "img/tree-04-d-trunk.faffc4a5.png";